// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__rockB","links":"styles_links__d2Nuq","copyright":"styles_copyright__d7ki1","link":"styles_link__TOhNU"};